export const SET_CURRENCY = "SET_CURRENCY";

// Retraining Costs
/**
 * Sets entire dictionary at store.costs.retrainCostDetails.
 */
export const SET_RETRAIN_COST_DETAIL = "SET_RETRAIN_COST_DETAIL";
/**
 * Sets value based on role and attribute in store.costs.retrainCostDetails.roles.
 */
export const SET_RETRAIN_COST_FOR_ROLE_ATTR = "SET_RETRAIN_COST_FOR_ROLE_ATTR";
/**
 * sets key-value pair (such as other costs) in store.costs.retrainCostDetails except for key of 'roles'.
 */
export const SET_RETRAIN_COMMON_ATTR = "SET_RETRAIN_COMMON_ATTR";

// Productivity Loss
/**
 * Sets entire dictionary at store.costs.prodLoss
 */
export const SET_PROD_LOSS = "SET_PROD_LOSS";
/**
 * Sets key-value pair in store.costs.prodLoss
 */
export const SET_PROD_LOSS_ATTR = "SET_PROD_LOSS_ATTR";

/**
 * Sets entire dictionary at store.costs.systemCostDetails
 */
export const SET_SYSTEM_COST = "SET_SYSTEM_COST";

/**
 * Sets key-value pair in store.costs.systemCostDetails
 */
export const SET_SYSTEM_COST_ATTR = "SET_SYSTEM_COST_ATTR";

/**
 * Sets entire dictionary at store.costs.costAdjustDetails
 */
export const SET_COST_ADJUST = "SET_COST_ADJUST";

/**
 * Sets key-value pair in store.costs.costAdjustDetails
 */
export const SET_COST_ADJUST_ATTR = "SET_COST_ADJUST_ATTR";

// status actions
export const SET_CODER_STATUS = "SET_CODER_STATUS";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";

/**
 * Sets entire dictionary at store.benefits
 */
export const SET_BENEFITS = "SET_BENEFITS";

// clear costs and benefits
export const CLEAR_COSTS = "CLEAR_COSTS";
export const CLEAR_BENEFITS = "CLEAR_BENEFITS";

/**
 * Sets key-value pair in store.benefits
 */
export const SET_BENEFITS_ATTR = "SET_BENEFITS_ATTR";

export const SET_SHOULD_SHOW_PDF_MODAL = "SET_SHOULD_SHOW_PDF_MODAL";
export const SET_SHOULD_SHOW_CLEAR_MODAL = "SET_SHOULD_SHOW_CLEAR_MODAL";
